import { useCareerProfessionCourseQuery } from 'core/graphql';

/** Что студенту делать с рекомендованным курсом (ТЗ 0071, п. 7.4). */
export type CourseAccess = 'available' | 'in_progress' | 'purchased_not_started';

export interface IProfessionNextCourse {
  courseId: string;
  courseName: string;
  /** Страница курса на сайте школы. */
  courseUrl: string;
  careerOutcome: string;
  durationLabel: string;
  access: CourseAccess;
  /** ИМЕНА пробелов, которые курс закроет. Без них «закроет 3 пробела» — ТЗ запрещает. */
  closesSkillNames: string[];
  criticalGaps: number;
  importantGaps: number;
  /** 'closes_critical' | 'closes_important' */
  reasonCode: string;
}

const toAccess = (value: string): CourseAccess =>
  value === 'in_progress' || value === 'purchased_not_started' ? value : 'available';

/**
 * Курс «следующего шага» для одной профессии.
 *
 * Отдельный запрос, а не поле списка профессий: сервер подбирает курс лениво,
 * и каталогу из шести карточек платить за шесть подборов незачем. Пройденный
 * курс сервер не предлагает вовсе — повторная покупка не рекомендуется.
 */
export const useProfessionCourse = (code: string) => {
  const { data, loading } = useCareerProfessionCourseQuery({
    fetchPolicy: 'cache-and-network',
    skip: !code,
  });
  const row = data?.careerProfessions.find((profession) => profession.code === code);
  const course = row?.nextCourse;
  const result: IProfessionNextCourse | null = course
    ? {
        courseId: course.courseId,
        courseName: course.courseName,
        courseUrl: course.courseUrl,
        careerOutcome: course.careerOutcome,
        durationLabel: course.durationLabel,
        access: toAccess(course.access),
        closesSkillNames: course.closesSkillNames,
        criticalGaps: course.criticalGaps,
        importantGaps: course.importantGaps,
        reasonCode: course.reasonCode,
      }
    : null;
  return { course: result, loading };
};
